import React from 'react';
import { getDataByIdEditable } from 'src/api/data/{id}/editable';

class AudioCallBasicInfoComponent extends React.Component {
    static defaultProps = {
        width: 340,
        rerenderOptimization: true,
    };
    privates = {
        basicReaf: React.createRef(),
        lineFlag: true,
        phoneFlag: false,
        highlightPoint: null,
        ticketIndex: 0,
        isEditable: false,
        editableLoading: false,
    };
    actions = {
        queryEditable() {
            const callId = this.props.detail?.callId;
            if (!callId) {
                this.privates.isEditable = false;
                return;
            }
            this.privates.editableLoading = true;
            this.actions.update();
            getDataByIdEditable({
                segments: { id: callId },
            }).then(
                (resp) => {
                    this.privates.isEditable = resp?.data === true;
                    this.privates.editableLoading = false;
                    this.actions.update();
                },
                () => {
                    this.privates.isEditable = false;
                    this.privates.editableLoading = false;
                    this.actions.update();
                }
            );
        },
        letOutline() {
            this.privates.basicReaf.current.style.width = '48px';
            this.privates.lineFlag = false;
            this.privates.phoneFlag = true;
            this.props.resizeWidthChange && this.props.resizeWidthChange(false);
            this.actions.update();
        },
        rightOutline() {
            this.privates.basicReaf.current.style.width = this.props.width + 'px';
            this.privates.lineFlag = true;
            this.privates.phoneFlag = false;
            this.props.resizeWidthChange && this.props.resizeWidthChange(true);
            this.actions.update();
        },
        setHighlightPoint (value) {
            this.privates.lineFlag = value;
            this.actions.update();
        },
        onTicketChange(value) {
            this.privates.ticketIndex = value;
            this.actions.update();
        }
    };
    // parseProps({ props, prevProps }) {
    //     return {
    //         content: props.content,
    //     };
    // }
    componentDidMount() {
        this.actions.queryEditable();
    }
    componentDidUpdate(prevProps) {
        if (this.props.detail?.callId !== prevProps.detail?.callId) {
            this.actions.queryEditable();
        }
    }
}
export default AudioCallBasicInfoComponent;
